var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-container"},[_c('v-img',{attrs:{"contain":"","lazy-src":_vm.noImage,"src":_vm.src}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }